var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCities, useCouriers } from '@src/app/pages/LookupPage/LookupHooks/Lookup.hooks';
import { useProductCategory } from '@src/app/pages/ProductCategoryPage/ProductCategoryHooks/ProductCategory.hooks';
import { SendProductContext } from '@src/app/pages/SendProductPage/SendProductNonTalent/SendProductNonTalent';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import ProductForm from '@src/components/molecules/SendProduct/Form/ProductForm';
import { useContext, useEffect, useState } from 'react';
import FileFormik from '../../Formik/Input/FileFormik';
import InputFormik from '../../Formik/Input/InputFormik';
import MultiSelectFormik from '../../Formik/MultiSelect/MultiSelectFormik';
import TextAreaFormik from '../../Formik/TextArea/TextAreaFormik';
var SendProductFormNonTalent = function (_a) {
    var _b, _c, _d;
    var tabName = _a.tabName, useForm = _a.useForm, isOpen = _a.isOpen, handleClose = _a.handleClose, onSubmit = _a.onSubmit, idForEdit = _a.idForEdit, size = _a.size;
    var currentData = useContext(SendProductContext);
    var _e = useState({
        page: 1,
        pageSize: 10,
        keyword: '',
        filterBy: '',
    }), filter = _e[0], setFilter = _e[1];
    var cities = useCities().cities;
    var couriers = useCouriers().couriers;
    var productCategory = useProductCategory().productCategory;
    var _f = useState([]), selectedCourier = _f[0], setSelectedCourier = _f[1];
    var _g = useState([]), selectedCategory = _g[0], setSelectedCategory = _g[1];
    var _h = useState([]), selectedProduct = _h[0], setSelectedProduct = _h[1];
    var _j = useState({
        proofTransferFilePubId: '',
    }), files = _j[0], setFiles = _j[1];
    var _k = useState(), selectedCity = _k[0], setSelectedCity = _k[1];
    // add identifier to differs between initial values from props and actual formik values
    var _l = useState(false), isAddedNewProduct = _l[0], setIsAddedNewProduct = _l[1];
    var optionCities = (cities === null || cities === void 0 ? void 0 : cities.data) &&
        cities.data.length > 0 &&
        cities.data.map(function (city) { return ({
            label: city.name,
            value: city.pubId,
        }); });
    var optionCouriers = (couriers === null || couriers === void 0 ? void 0 : couriers.data) &&
        couriers.data.length > 0 &&
        couriers.data.map(function (courier) { return ({
            label: courier.name,
            value: courier.pubId,
        }); });
    var optionProductCategories = productCategory &&
        productCategory.length > 0 &&
        productCategory.map(function (pcategory) { return ({
            label: pcategory.name,
            value: pcategory.pubId,
        }); });
    var onChangeFiles = function (e) {
        var _a;
        setFiles(__assign(__assign({}, files), (_a = {}, _a[e.target.name] = e.target.files, _a)));
        useForm.setFieldValue(e.target.name, e.target.files);
    };
    var onChangeCourier = function (e) {
        setSelectedCourier(e);
        useForm.setFieldValue('courierPubId', e.value);
    };
    var onChangeCity = function (e) {
        setSelectedCity(e);
        useForm.setFieldValue('cityPubId', e.value);
    };
    var handleAdd = function () {
        var newProduct = {
            productPubId: '',
            productCategoryPubId: '',
            qty: 1,
        };
        var productValue = __spreadArray(__spreadArray([], useForm.values.sendProduct.products, true), [newProduct], false);
        useForm.setFieldValue('sendProduct.products', productValue);
        var newItemObject = {
            label: '',
            value: '',
        };
        setSelectedCategory(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [newItemObject], false); });
        setSelectedProduct(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [newItemObject], false); });
        // setEditableValue(useForm.values.sendProduct.products)
        setIsAddedNewProduct(true);
    };
    var handleRemove = function (position) {
        setSelectedProduct(selectedProduct.map(function (p, index) {
            if (position === index) {
                return { label: '', value: '' };
            }
            return p;
        }));
        setSelectedCategory(selectedCategory.map(function (c, index) {
            if (position === index) {
                return { label: '', value: '' };
            }
            return c;
        }));
        useForm.setValues(__assign(__assign({}, useForm.values), { sendProduct: {
                products: useForm.values.sendProduct.products.filter(function (_, index) { return index !== position; }),
            } }));
    };
    var onChangeCategoryList = function (e, position) {
        var updatedCategoryList = selectedCategory.map(function (category, index) {
            if (index === position) {
                return e;
            }
            else {
                return category;
            }
        });
        var updatedProductList = selectedProduct.map(function (p, idx) {
            if (idx === position)
                return { value: '', label: '' };
            return p;
        });
        setSelectedCategory(selectedCategory.length ? updatedCategoryList : [e]);
        setSelectedProduct(updatedProductList);
        setFilter(__assign(__assign({}, filter), { filterBy: JSON.stringify([['productCategory.pubId', e.value]]) }));
        useForm.setFieldValue("sendProduct.products[".concat(position, "].productCategoryPubId"), e.value);
    };
    var onChangeProductList = function (e, position) {
        var updatedProductList = selectedProduct.map(function (product, index) {
            if (index === position) {
                return e;
            }
            else {
                return product;
            }
        });
        setSelectedProduct(selectedProduct.length ? updatedProductList : [e]);
        useForm.setFieldValue("sendProduct.products[".concat(position, "].productPubId"), e.value);
    };
    var openItem = function (file) {
        window.open("".concat(file), '_blank');
    };
    // const handleblur = (e: any, index: any) => (editableValue[index].qty = e.target.value)
    var onLoadProductCategoryList = function () {
        var _a;
        var productCategoryData = (_a = currentData === null || currentData === void 0 ? void 0 : currentData.details) === null || _a === void 0 ? void 0 : _a.map(function (category) {
            var _a, _b, _c, _d;
            return {
                label: ((_b = (_a = category === null || category === void 0 ? void 0 : category.product) === null || _a === void 0 ? void 0 : _a.productCategory) === null || _b === void 0 ? void 0 : _b.name) || '',
                value: ((_d = (_c = category === null || category === void 0 ? void 0 : category.product) === null || _c === void 0 ? void 0 : _c.productCategory) === null || _d === void 0 ? void 0 : _d.pubId) || '',
            };
        });
        setSelectedCategory(productCategoryData);
    };
    var onLoadProductList = function () {
        var _a;
        var productList = (_a = currentData === null || currentData === void 0 ? void 0 : currentData.details) === null || _a === void 0 ? void 0 : _a.map(function (detail) {
            var _a, _b;
            return {
                label: ((_a = detail === null || detail === void 0 ? void 0 : detail.product) === null || _a === void 0 ? void 0 : _a.name) || '',
                value: ((_b = detail === null || detail === void 0 ? void 0 : detail.product) === null || _b === void 0 ? void 0 : _b.pubId) || '',
            };
        });
        setSelectedProduct(productList);
    };
    var onLoadCourierData = function () {
        var _a, _b;
        if (couriers) {
            var courierData = couriers === null || couriers === void 0 ? void 0 : couriers.data.find(function (courier) { var _a; return courier.pubId === ((_a = currentData === null || currentData === void 0 ? void 0 : currentData.courier) === null || _a === void 0 ? void 0 : _a.pubId); });
            var data = {
                label: (_a = courierData === null || courierData === void 0 ? void 0 : courierData.name) !== null && _a !== void 0 ? _a : '',
                value: (_b = courierData === null || courierData === void 0 ? void 0 : courierData.pubId) !== null && _b !== void 0 ? _b : '',
            };
            setSelectedCourier([data]);
        }
    };
    var onLoadCityData = function () {
        var _a, _b;
        if (cities) {
            var citiesData = cities === null || cities === void 0 ? void 0 : cities.data.find(function (city) { return city.pubId === useForm.values.cityPubId; });
            var data = {
                label: (_a = citiesData === null || citiesData === void 0 ? void 0 : citiesData.name) !== null && _a !== void 0 ? _a : '',
                value: (_b = citiesData === null || citiesData === void 0 ? void 0 : citiesData.pubId) !== null && _b !== void 0 ? _b : '',
            };
            setSelectedCity([data]);
        }
    };
    useEffect(function () {
        if (currentData) {
            onLoadCourierData();
            onLoadProductCategoryList();
            onLoadProductList();
            onLoadCityData();
        }
    }, [currentData, couriers]);
    return (_jsx(_Fragment, { children: _jsx(DrawerComponent, __assign({ size: size, open: isOpen, handleClose: function () { return handleClose(false); } }, { children: _jsx("div", { children: _jsxs("form", __assign({ id: 'transfer-form', className: 'form', noValidate: true, onSubmit: useForm.handleSubmit }, { children: [_jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(InputFormik, { label: 'Recipient Name', formik: useForm, name: 'recipientName', placeholder: 'Recipient Name', type: 'text' }) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(InputFormik, { label: 'Phone Number', formik: useForm, name: 'phoneNumber', placeholder: 'Phone Number', type: 'text' }) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(InputFormik, { label: 'Address', formik: useForm, name: 'address', placeholder: 'Address', type: 'text' }) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(MultiSelectFormik, { name: 'cityPubId', label: 'City Name', formik: useForm, isMulti: false, options: optionCities || [], value: selectedCity || [], onchange: onChangeCity }) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: optionCouriers && selectedCourier && (_jsx(MultiSelectFormik, { name: 'courierPubId', label: 'Kurir', formik: useForm, isMulti: false, options: optionCouriers, value: selectedCourier, onchange: onChangeCourier })) }) })), _jsx("div", __assign({ className: 'mb-3' }, { children: _jsx("div", { children: _jsx(TextAreaFormik, { label: 'Note', placeholder: 'Note', name: 'note', formik: useForm }) }) })), _jsxs("div", __assign({ className: 'mb-3' }, { children: [_jsx("div", { children: _jsx(FileFormik, { label: 'Bukti Transfer', placeholder: 'Input invoice here', name: 'proofTransferFilePubId', formik: useForm, onChange: onChangeFiles }) }), useForm.values.proofTransferFilePubId !== '' ? (_jsx("div", __assign({ className: 'mb-5' }, { children: _jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-success', onClick: function () { return openItem(useForm.values.proofTransferFilePubId); } }, { children: "Lihat Bukti Transfer" })) }))) : undefined, useForm.values.proofTransferFilePubId !== '' ? (_jsx("div", __assign({ className: 'mb-5', style: { marginTop: '-1rem', color: 'red', fontStyle: 'italic' } }, { children: "*change this file will replace current transfer proof in server" }))) : undefined] })), _jsxs("div", __assign({ className: 'mb-5 py-3' }, { children: [_jsx("div", __assign({ className: 'float-start' }, { children: _jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "List Barang" })) })), _jsx("div", __assign({ className: 'float-end mb-3' }, { children: _jsx("button", __assign({ type: 'button', className: 'btn btn-sm btn-success', onClick: handleAdd }, { children: "Add Barang" })) }))] })), _jsx("div", __assign({ className: 'mt-15 d-flex' }, { children: _jsx("div", __assign({ className: 'float-start' }, { children: (_d = (_c = (_b = useForm.values) === null || _b === void 0 ? void 0 : _b.sendProduct) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.map(function (categories, index) { return (_jsx(ProductForm, { useForm: useForm, index: index, productCategoryList: optionProductCategories, removeProduct: handleRemove, onchangecategory: onChangeCategoryList, onchangeproduct: onChangeProductList, selectedcategory: selectedCategory[index], selectedproduct: selectedProduct[index], handleBlur: function () { }, name: 'sendProduct.products' }, index)); }) })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: function () { return handleClose(false); }, style: { marginRight: '1rem' }, disabled: useForm.isSubmitting }, { children: "Batal" })), _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-active-light-primary mr-2 btn-sm', disabled: useForm.isSubmitting }, { children: [!useForm.isSubmitting && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), useForm.isSubmitting && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) }) })) }));
};
export default SendProductFormNonTalent;
